import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as uiActions from '../../../actions/uiActions';
import * as updateConfigurationActions from '../../../actions/updateConfigurationActions';
import {ModalButton} from '../../../components/ModalButton';
import {ScrollListView} from '../../../components/ScrollListView';
import {AccessoryCard} from './AccessoryCard';
import * as _ from 'lodash';
// import {kinds} from '../ConfiguratorAccessory';
import { isConfigRequested } from '../../../services/configurationWarningChecks'
import { TranslationContext } from "../../../context/TranslationContext";
import {gtmPro} from '../../../services/gtmPro';

/**
 * ModalButton permettant de choisir un accessoire
 */
class AccessoryPickerComponent extends Component {
  static contextType = TranslationContext;
  static propTypes = {
    configuration: PropTypes.shape({
      monument: PropTypes.shape({
        graniteMain: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    kind: PropTypes.string.isRequired,
    allGranites: PropTypes.arrayOf(PropTypes.shape({
      reference: PropTypes.string.isRequired,
      madeInFrance: PropTypes.bool,
    })),
  };

  state;
  modal;

  constructor(props) {
    super(props);
    this.state = {
      drawing: props.drawing,
      kind: props.kind,
      maxAcc: 12
    };
  }

  onSelectAccessory = (accessory) => granite => {
    const accessories = this.props.configuration.accessories;
    const {maxAcc} = this.state;
    if (accessories && accessories.length < maxAcc){
      gtmPro().clickAccessory(accessory);
      this.props.actions.addAccessory(accessory, granite);
      this.modal.close();
      this.resetState();
    } else {
      alert("Vous ne pouvez ajouter que 12 accessoires au maximum.")
    }
  };

  resetState = () => {
    this.setState({
      kind: this.props.kind
    });
  }

  onClickDisabled = () => {
    this.props.uiActions.addMessage({
      id: 'accessories-picker-unavailable',
      className: 'warning',
      innerHTML: 'Aucun accessoire pour le monument dans ce granit'
    })
  };

  onSelectKind = (kind, gtmName) => {
    gtmPro().ctaOfConfiguration(
      {
        name: gtmName,
        category: "configurateur",
        subcategory: "Accessoires",
        type: "cta",
        from: "left"
      },
      {template: "configurateur", subtemplate: "accessoires"},
      {},
      "partner",
      "product",
      "user",
      "page"
    );
    this.setState({kind});
    this.trackAccessoriesList(kind);
  }

  getFilteredAccessories = (kind) => {
    const {configuration, allAccessories, allGranites} = this.props;
    const fullMonumentGranite = _.find(allGranites, {reference: configuration.monument.graniteMain});
    const isMonumentMadeInFrance = fullMonumentGranite && fullMonumentGranite.madeInFrance;

    if (configuration.monument.kind === 'ACC') {
      return _.chain(allAccessories)
        .filter({kind: kind})
        .filter(accessory => _.some(accessory.granites, {madeInFranceAndImported: true}) || (accessory.granites && accessory.granites.length > 0))
        .value();
    }

    return _.chain(allAccessories)
      .filter({kind: kind})
      .filter(accessory =>
        accessory.reference.startsWith("ACI") || accessory.reference.startsWith("AG") || accessory.reference.startsWith("AM") ||  
        _.some(accessory.granites, {reference: configuration.monument.graniteMain}) ||
        _.some(accessory.granites, {reference: configuration.monument.graniteSecondary})
      ).filter(accessory => _.some(accessory.granites, {madeInFranceAndImported: true}) || _.some(accessory.granites, {madeInFrance: isMonumentMadeInFrance}))
      .value();
  }

  trackAccessoriesList = (kind) => {
    const accessories = this.getFilteredAccessories(kind);
    gtmPro().listAccessories(accessories);
  }

  getAccessoryPickerCtaName = () => {
    switch (this.props.kind) {
      case "Vase":
        return "extranet.config3d.config3d_accessories_button_vase";
      case "Jardinière":
        return "extranet.config3d.config3d_accessories_button_planter";
      case "Divers":
        return "extranet.config3d.config3d_accessories_button_other";
      default:
        return "";
    }
  }

  onOpenPickerClick = () => {
    const gtmName = this.getAccessoryPickerCtaName();
    if (!gtmName) return;
    const isOpening = this.modal && this.modal.state ? !this.modal.state.open : true;
    gtmPro().ctaOfConfiguration(
      {
        name: gtmName,
        category: "configurateur",
        subcategory: "Accessoires",
        type: "cta",
        from: "left"
      },
      {template: "configurateur", subtemplate: "accessoires"},
      {},
      "partner",
      "product",
      "user",
      "page"
    );

    if (isOpening) {
      this.trackAccessoriesList(this.state.kind);
    }
  }

  renderItem = (madeInFrance) => (accessory) => {
    return (
      <AccessoryCard key={accessory.reference}
                     configuration={this.props.configuration}
                     accessory={accessory}
                     onSelectAccessory={this.onSelectAccessory(accessory)}
                     madeInFrance={madeInFrance}
      />
    );
  };

  render() {
    const t = this.context;
    const kinds = {
      'Vase': {
        id: 'Vase',
        label: t("config3d_accessories_button_vase") || "Vases",
      },
      'Jardinière': {
        id: 'Jardinière',
        label: t("config3d_accessories_button_planter") || "Jardinières",
      },
      'Divers': {
        id: 'Divers',
        label: t("config3d_accessories_button_other") || "Autres...",
      },
    };
    const {configuration} = this.props;

    const fullMonumentGranite = _.find(this.props.allGranites, {reference: configuration.monument.graniteMain});
    const isMonumentMadeInFrance = fullMonumentGranite && fullMonumentGranite.madeInFrance;
    const kind = this.state.kind;

    const accessories = this.getFilteredAccessories(kind);
    const vaseAccessories = this.getFilteredAccessories('Vase');
    const jardiniereAccessories = this.getFilteredAccessories('Jardinière');
    const diversAccessories = this.getFilteredAccessories('Divers');
  
    if (accessories.length) {
      return (
        <div className="btn-wrapper">
          <ModalButton ref={(_modal) => this.modal = _modal} buttonContent={kinds[this.props.kind].label}
            buttonIcon={this.props.buttonIcon}
            buttonClassName={` ${this.props.buttonClassName ? this.props.buttonClassName : ''}`} 
            disabled={!accessories.length || isConfigRequested()}
            className="buttonModal background-page"
            toggleSteps={this.props.toggleSteps}
            launchIntro={this.props.launchIntro}
            modalName={this.props.modalName}
            onClick={this.onOpenPickerClick}
            onModalClose={this.resetState}>
            <div className="Header">
              <div className="HeaderContainer">
                <h1>
                  { t("config3d_accessories_modal_title") || "Sélectionnez un accessoire" }
                </h1>
                <span className="maxSpan">
                  { t("config3d_accessories_modal_subtitle") || "(12 au maximum)" }
                </span>
              </div>
            </div>

            <div className="buttonsContainer buttons-group">
              <button disabled={vaseAccessories.length === 0} className={`kindButton ${kind==='Vase' ? 'selectedKind' : ''} ${vaseAccessories.length === 0 ? 'btn-disabled disabled' : ''} `} onClick={() => this.onSelectKind("Vase", "extranet.config3d.config3d_accessories_button_vase")}><i className="icon icon-accessory-vase" /> <span>{ t("config3d_accessories_button_vase") || "Vases" }</span></button>
              <button disabled={jardiniereAccessories.length === 0} className={`kindButton ${kind==='Jardinière' ? 'selectedKind' : ''} ${jardiniereAccessories.length === 0 ? 'btn-disabled disabled' : ''}`} onClick={() => this.onSelectKind("Jardinière", "extranet.config3d.config3d_accessories_button_planter")}><i className="icon icon-accessory-box" /> <span>{ t("config3d_accessories_button_planter") || "Jardinières" }</span></button>
              <button disabled={diversAccessories.length === 0} className={`kindButton ${kind==='Divers' ? 'selectedKind' : ''} ${diversAccessories.length === 0 ? 'btn-disabled disabled' : ''}`} onClick={() => this.onSelectKind("Divers", "extranet.config3d.config3d_accessories_button_other")} ><i className="icon icon-accessories-misc"/><span>{ t("config3d_accessories_button_other") || "Autres" }</span></button>
            </div>

            <ScrollListView items={accessories} renderItem={this.renderItem(isMonumentMadeInFrance)} className="AccessoryPicker"/>
          </ModalButton>
        </div>
      )
    } else {
      return (
        <div className="btn-wrapper">
          <div className="btn-config">
            <button className="btn-config-secondary config-button-background text-dark disabled SquareButton"
                    title="Aucun accessoire pour le monument dans ce granit"
                    onClick={this.onClickDisabled}
                    disabled={true}>
              <span className={`${this.props.buttonIcon } icon icon-large`}></span>
              <div>{kinds[this.props.kind].label}</div>
            </button>
          </div>
        </div>
      )
    }
  }
}

export const AccessoryPicker = connect((state, ownProps) => ({
    configuration: state.configurator.current.configuration,
    allAccessories: state.configurator.accessories,
    allGranites: state.configurator.current.options.granites,
    catalog: state.catalog,
  }),
  (dispatch) => ({
    uiActions: bindActionCreators(uiActions, dispatch),
    actions: bindActionCreators(updateConfigurationActions, dispatch),
  })
)(AccessoryPickerComponent);
